import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Phuluc6 from "components/Tonghopvantai/Phuluc6.js";
export default function Phuluc6TH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Phụ lục 6",
            tabContent: <Phuluc6 />,
          },
        ]}
      />
    </div>
  );
}
